module.exports = __webpack_public_path__ + "img/shared_icon.81c58323.png";